import React, { useMemo, useState } from "react";
import "./restoration-project.css";

import heroImage from "../assets/matchlessg3wo.jpeg";
import bikeCutout from "../assets/bikes/g3wo3.avif";

// Before / after
import before1 from "../assets/restoration/before_1.jpg";
import complete2 from "../assets/restoration/complete_2.avif";

// Found / before
import before2 from "../assets/restoration/before_2.jpg";
import before3 from "../assets/restoration/before_3.jpg";
import looseTogether from "../assets/restoration/loose_together.avif";
import img5616 from "../assets/restoration/IMG_5616.avif";
import img5617 from "../assets/restoration/IMG_5617.avif";
import img5619 from "../assets/restoration/IMG_5619.avif";
import img5627 from "../assets/restoration/IMG_5627.avif";
import wheels from "../assets/restoration/wheels.avif";

// Pre-assembly
import preAssembly1 from "../assets/restoration/pre_assembly_1.avif";
import preAssembly2 from "../assets/restoration/pre_assembly_2.avif";
import preAssembly3 from "../assets/restoration/pre_assembly_3.avif";
import preAssembly4 from "../assets/restoration/pre_assembly_4.avif";
import preAssembly5 from "../assets/restoration/pre_assembly_5.avif";
import preAssembly6 from "../assets/restoration/pre_assembly_6.avif";
import preAssembly7 from "../assets/restoration/pre_assembly_7.avif";
import preAssembly8 from "../assets/restoration/pre_assembly_8.avif";
import preAssembly9 from "../assets/restoration/pre_assembly_9.avif";
import preAssembly10 from "../assets/restoration/pre_assembly_10.avif";
import preAssembly11 from "../assets/restoration/pre_assembly_11.avif";
import preAssembly12 from "../assets/restoration/pre_assembly_12.avif";
import preAssembly13 from "../assets/restoration/pre_assembly_13.avif";
import preAssembly14 from "../assets/restoration/pre_assembly_14.avif";
import preAssembly15 from "../assets/restoration/pre_assembly_15.avif";
import preAssembly16 from "../assets/restoration/pre_assembly_16.avif";
import preAssembly17 from "../assets/restoration/pre_assembly_17.avif";
import preAssembly18 from "../assets/restoration/pre_assembly_18.avif";
import preAssembly19 from "../assets/restoration/pre_assembly_19.avif";
import preAssembly20 from "../assets/restoration/pre_assembly_20.avif";
import preAssembly21 from "../assets/restoration/pre_assembly_21.avif";

// Tank / paint
import tank1 from "../assets/restoration/tank_1.avif";
import tank2 from "../assets/restoration/tank_2.avif";
import tankPaint1 from "../assets/restoration/tank_paint_1.avif";

// Gearbox
import gearbox1 from "../assets/restoration/gearbox_1.avif";
import gearbox2 from "../assets/restoration/gearbox_2.avif";
import gearbox3 from "../assets/restoration/gearbox_3.avif";
import gearbox4 from "../assets/restoration/gearbox_4.avif";
import gearbox5 from "../assets/restoration/gearbox_5.avif";
import gearbox6 from "../assets/restoration/gearbox_6.avif";
import gearbox7 from "../assets/restoration/gearbox_7.avif";
import gearbox8 from "../assets/restoration/gearbox_8.avif";
import gearbox9 from "../assets/restoration/gearbox_9.avif";

// Engine
import engine1 from "../assets/restoration/engine_1.avif";
import engine2 from "../assets/restoration/engine_2.avif";
import engine3 from "../assets/restoration/engine_3.avif";
import engine4 from "../assets/restoration/engine_4.avif";
import engine5 from "../assets/restoration/engine_5.avif";
import engine6 from "../assets/restoration/engine_6.avif";
import engine7 from "../assets/restoration/engine_7.avif";

// Clutch
import clutch from "../assets/restoration/clutch.avif";

// Dynamo
import dynamo1 from "../assets/restoration/dynamo_1.avif";
import dynamo2 from "../assets/restoration/dynamo_2.avif";
import dynamo3 from "../assets/restoration/dynamo_3.avif";
import dynamo4 from "../assets/restoration/dynamo_4.avif";
import dynamo5 from "../assets/restoration/dynamo_5.avif";
import dynamo6 from "../assets/restoration/dynamo_6.avif";
import dynamo7 from "../assets/restoration/dynamo_7.avif";

// Final assembly
import finalAssembly1 from "../assets/restoration/final_assembly_1.avif";
import finalAssembly2 from "../assets/restoration/final_assembly_2.avif";
import finalAssembly3 from "../assets/restoration/final_assembly_3.avif";
import finalAssembly4 from "../assets/restoration/final_assembly_4.avif";
import finalAssembly5 from "../assets/restoration/final_assembly_5.avif";
import finalAssembly6 from "../assets/restoration/final_assembly_6.avif";
import finalAssembly7 from "../assets/restoration/final_assembly_7.avif";
import finalAssembly8 from "../assets/restoration/final_assembly_8.avif";

// Complete
import complete1 from "../assets/restoration/complete_1.avif";

const timelineSteps = [
  {
    title: "Project Bike",
    date: "As Found",
    text: "The bike was acquired as a tired but largely complete machine, retaining much of its original character and many core components. These photographs show its condition before work began, along with early inspection and disassembly.",
    notes: [
      "Largely complete machine",
      "Strong basis for restoration",
      "Original character retained",
      "Initial inspection and stripdown recorded",
    ],
    image: before1,
    gallery: [before1, before2, before3, looseTogether, img5616, img5617, img5619, img5627, wheels],
  },
  {
    title: "Engine Rebuild",
    date: "Engine Work",
    text: "The engine was dismantled, cleaned, inspected and rebuilt, with worn internal parts replaced where needed. The photographs document the major stages of the engine work and associated components.",
    notes: [
      "Engine dismantled and inspected",
      "Worn parts renewed where required",
      "Internal components cleaned and rebuilt",
      "Associated ancillaries refurbished",
    ],
    image: engine1,
    gallery: [engine1, engine2, engine3, engine4, engine5, engine6, engine7, clutch],
  },
  {
    title: "Gearbox & Transmission",
    date: "Gearbox Work",
    text: "The gearbox and transmission components were stripped, examined and rebuilt as part of the overall restoration, ensuring proper operation before final assembly.",
    notes: [
      "Gearbox stripped and inspected",
      "Components cleaned",
      "Transmission parts checked",
      "Rebuilt ready for reassembly",
    ],
    image: gearbox1,
    gallery: [gearbox1, gearbox2, gearbox3, gearbox4, gearbox5, gearbox6, gearbox7, gearbox8, gearbox9],
  },
  {
    title: "Electrical Components",
    date: "Electrical Refurbishment",
    text: "Electrical ancillaries including the dynamo were rebuilt and prepared for reuse, helping preserve as much originality as possible while returning the system to reliable working order.",
    notes: [
      "Dynamo dismantled and cleaned",
      "Electrical components assessed",
      "Original units retained where possible",
      "Prepared for reliable service",
    ],
    image: dynamo1,
    gallery: [dynamo1, dynamo2, dynamo3, dynamo4, dynamo5, dynamo6, dynamo7],
  },
  {
    title: "Paint & Tank Work",
    date: "Refinishing",
    text: "Tank and painted components were refinished in a period-correct manner, with care taken to achieve a finish that looked right for the machine rather than overly modern.",
    notes: [
      "Tank prepared and refinished",
      "Correct period appearance aimed for",
      "Paintwork documented through the process",
      "Details restored carefully",
    ],
    image: tankPaint1,
    gallery: [tank1, tank2, tankPaint1],
  },
  {
    title: "Pre-Assembly",
    date: "Trial Build-Up",
    text: "Before final completion, the major components were progressively brought together to check fit, alignment and finish. This stage documents the machine coming back to life piece by piece.",
    notes: [
      "Major components trial-fitted",
      "Alignment checked",
      "Build sequence documented",
      "Final issues resolved before completion",
    ],
    image: preAssembly1,
    gallery: [
      preAssembly1, preAssembly2, preAssembly3, preAssembly4, preAssembly5,
      preAssembly6, preAssembly7, preAssembly8, preAssembly9, preAssembly10,
      preAssembly11, preAssembly12, preAssembly13, preAssembly14, preAssembly15,
      preAssembly16, preAssembly17, preAssembly18, preAssembly19, preAssembly20,
      preAssembly21,
    ],
  },
  {
    title: "Final Assembly",
    date: "Completed Rebuild",
    text: "With all major restoration work complete, the bike was reassembled, adjusted and finished. These photographs show the machine in its completed form.",
    notes: [
      "Final assembly completed",
      "Mechanical setup finished",
      "Presentation completed",
      "Road-ready restored machine",
    ],
    image: finalAssembly1,
    gallery: [
      finalAssembly1, finalAssembly2, finalAssembly3, finalAssembly4, finalAssembly5,
      finalAssembly6, finalAssembly7, finalAssembly8, complete1, complete2,
    ],
  },
];

const componentCards = [
  { title: "Engine", status: "Rebuilt" },
  { title: "Gearbox", status: "Rebuilt" },
  { title: "Electrical", status: "Refurbished" },
  { title: "Paint", status: "Completed" },
  { title: "Assembly", status: "Completed" },
];

const partsSuppliers = [
  { part: "Cylinder Head", supplier: "AMC Classic Spares" },
  { part: "Bearings", supplier: "Simply Bearings" },
  { part: "Gaskets", supplier: "Specialist supplier" },
  { part: "Cables", supplier: "Custom made" },
  { part: "Paint", supplier: "Locally matched finish" },
];

function Lightbox({ image, alt, onClose }) {
  if (!image) return null;

  return (
    <div className="rp-lightbox" onClick={onClose} role="dialog" aria-modal="true">
      <button
        type="button"
        className="rp-lightbox__close"
        onClick={onClose}
        aria-label="Close image"
      >
        ×
      </button>

      <div className="rp-lightbox__inner" onClick={(e) => e.stopPropagation()}>
        <img src={image} alt={alt} className="rp-lightbox__image" />
      </div>
    </div>
  );
}

function TimelineGallery({ photos, title, onOpen }) {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 4;

  const visiblePhotos = useMemo(
    () => photos.slice(startIndex, startIndex + visibleCount),
    [photos, startIndex]
  );

  const canGoBack = startIndex > 0;
  const canGoForward = startIndex + visibleCount < photos.length;

  const goBack = () => {
    if (canGoBack) {
      setStartIndex((prev) => Math.max(prev - visibleCount, 0));
    }
  };

  const goForward = () => {
    if (canGoForward) {
      setStartIndex((prev) => Math.min(prev + visibleCount, photos.length - visibleCount));
    }
  };

  return (
    <div className="rp-gallery-carousel">
      <div className="rp-gallery-carousel__top">
        <button
          type="button"
          className="rp-gallery-arrow"
          onClick={goBack}
          disabled={!canGoBack}
          aria-label={`Previous ${title} photos`}
        >
          ‹
        </button>

        <div className="rp-gallery-row">
          {visiblePhotos.map((photo, index) => {
            const actualIndex = startIndex + index;
            return (
              <button
                key={`${title}-${actualIndex}`}
                type="button"
                className="rp-gallery-thumb-button"
                onClick={() => onOpen(photo, `${title} ${actualIndex + 1}`)}
              >
                <img
                  src={photo}
                  alt={`${title} ${actualIndex + 1}`}
                  className="rp-gallery-thumb"
                  loading="lazy"
                  decoding="async"
                />
              </button>
            );
          })}
        </div>

        <button
          type="button"
          className="rp-gallery-arrow"
          onClick={goForward}
          disabled={!canGoForward}
          aria-label={`Next ${title} photos`}
        >
          ›
        </button>
      </div>

      {photos.length > visibleCount && (
        <div className="rp-gallery-count">
          Showing {startIndex + 1}–{Math.min(startIndex + visibleCount, photos.length)} of {photos.length}
        </div>
      )}
    </div>
  );
}

function TimelineStepCard({ step, index, onOpenImage }) {
  return (
    <article className="rp-timeline__item">
      <div className="rp-timeline__marker">
        <span>{index + 1}</span>
      </div>

      <div className="rp-timeline__card">
        <button
          type="button"
          className="rp-timeline__media rp-timeline__media--button"
          onClick={() => onOpenImage(step.image, step.title)}
        >
          <img src={step.image} alt={step.title} loading="lazy" decoding="async" />
        </button>

        <div className="rp-timeline__body">
          <div className="rp-timeline__meta">{step.date}</div>
          <h3>{step.title}</h3>
          <p>{step.text}</p>

          <ul className="rp-note-list">
            {step.notes.map((note) => (
              <li key={note}>{note}</li>
            ))}
          </ul>

          {step.gallery?.length > 0 && (
            <TimelineGallery
              photos={step.gallery}
              title={step.title}
              onOpen={onOpenImage}
            />
          )}
        </div>
      </div>
    </article>
  );
}

export default function RestorationProjectPage() {
  const [lightboxImage, setLightboxImage] = useState(null);
  const [lightboxAlt, setLightboxAlt] = useState("");

  const openImage = (image, alt) => {
    setLightboxImage(image);
    setLightboxAlt(alt);
  };

  const closeImage = () => {
    setLightboxImage(null);
    setLightboxAlt("");
  };

  return (
    <div className="rp-page">
      <section
        className="rp-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(32,24,16,0.38), rgba(32,24,16,0.52)), url(${heroImage})`,
        }}
      >
        <div className="rp-hero__inner">
          <div className="rp-hero__eyebrow">Restoration Project</div>
          <h1 className="rp-hero__title">Matchless G3WO Restoration</h1>
          <div className="rp-hero__meta">1940 • Full Ground-Up Rebuild</div>
        </div>
      </section>

      <div className="rp-shell">
        <section id="restoration-overview" className="rp-overview-card">
          <div className="rp-overview-card__image">
            <img src={bikeCutout} alt="Restoration project bike" loading="lazy" />
          </div>

          <div className="rp-overview-card__content">
            <div className="rp-section-label">Project Overview</div>
            <h2>Ground up Rebuild</h2>

            <div className="rp-spec-grid">
              <div>
                <span>Model</span>
                <strong>Matchless G3WO</strong>
              </div>
              <div>
                <span>Year</span>
                <strong>1940</strong>
              </div>
              <div>
                <span>Engine</span>
                <strong>350cc OHV</strong>
              </div>
              <div>
                <span>Completed</span>
                <strong>May 2024</strong>
              </div>
            </div>

            <p className="rp-overview-card__text">
              This page documents the full restoration of this 1940 Matchless G3WO,
              from the bike as found through stripdown, engine and cycle-part work,
              refinishing, and final reassembly. Rather than a live build log, it serves
              as a record of the completed restoration and the work carried out along the way.
            </p>
          </div>
        </section>

        <section className="rp-section">
          <div className="rp-section-heading">
            <div className="rp-section-label">Workshop Journal</div>
            <h2>Restoration Timeline</h2>
            <p>
              A step-by-step record of the work carried out during the restoration, from the initial condition of the bike through to its completed rebuild.
            </p>
          </div>

          <div className="rp-timeline">
            {timelineSteps.map((step, index) => (
              <TimelineStepCard
                key={step.title}
                step={step}
                index={index}
                onOpenImage={openImage}
              />
            ))}
          </div>
        </section>

        <section className="rp-section">
          <div className="rp-section-heading">
            <div className="rp-section-label">By Component</div>
            <h2>Component Breakdown</h2>
            <p>
              The restoration involved a full rebuild of the major mechanical and cosmetic areas of the machine.
            </p>
          </div>

          <div className="rp-component-grid">
            {componentCards.map((card) => (
              <article key={card.title} className="rp-component-card">
                <div className="rp-component-card__icon">{card.title.charAt(0)}</div>
                <h3>{card.title}</h3>
                <p>{card.status}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="rp-section rp-section--split">
          <div className="rp-section-heading">
            <div className="rp-section-label">Workshop Reference</div>
            <h2>Parts & Suppliers</h2>
            <p>
              A running list of key parts sources used during the project.
            </p>
          </div>

          <div className="rp-parts-card">
            <div className="rp-parts-table">
              <div className="rp-parts-table__head">Part</div>
              <div className="rp-parts-table__head">Supplier</div>

              {partsSuppliers.map((item) => (
                <React.Fragment key={item.part}>
                  <div className="rp-parts-table__cell">{item.part}</div>
                  <div className="rp-parts-table__cell">{item.supplier}</div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </section>

        <section className="rp-section">
          <div className="rp-section-heading">
            <div className="rp-section-label">Visual Progress</div>
            <h2>Before & After</h2>
            <p>
              A simple side-by-side comparison of the machine before restoration and after completion.
            </p>
          </div>

          <div className="rp-compare-grid">
            <figure className="rp-compare-card">
              <img src={before1} alt="Bike before restoration" loading="lazy" decoding="async" />
              <figcaption>Before</figcaption>
            </figure>

            <figure className="rp-compare-card">
              <img src={complete2} alt="Bike after restoration work" loading="lazy" decoding="async" />
              <figcaption>Completed</figcaption>
            </figure>
          </div>
        </section>

        <section className="rp-section rp-footer-card">
          <div className="rp-section-label">Project Notes</div>
          <h2>A completed restoration record</h2>
          <p>
            This page preserves the story of the rebuild, bringing together the main stages,
            photographs, parts sources and notes from the restoration of the machine.
          </p>
        </section>
      </div>

      <Lightbox image={lightboxImage} alt={lightboxAlt} onClose={closeImage} />
    </div>
  );
}
